// extracted by mini-css-extract-plugin
export default {"body":"body__9f05f93e","tabs":"tabs__9f05f93e","list":"list__9f05f93e","pagination":"pagination__9f05f93e"};